import s, { useState as h, useCallback as f, useEffect as T } from "react";
import { c as g, t as B } from "./app-a75c1d35.mjs";
import { C as v } from "./Chips-2709174d.mjs";
import { B as x } from "./Block-9b78bd10.mjs";
import "./Link-479ac100.mjs";
import "./LinkContext-0c83848a.mjs";
import "./Icon-3122c134.mjs";
const k = "rich-text", E = "hero__text", P = "mobile", N = "tablet", S = "desktop", L = "button__text-primary", G = "button__title", F = "button__title__map", H = "button__heroTitle", w = "heading__page", A = "heading__section", O = "heading__menu", V = "texts__component_title", j = "texts__component_title--bold", M = "texts__lead_text", D = "page__lead_text", I = "texts__lead_text--bold", R = "texts__paragraph_subtitle", W = "texts__paragraph_subtitle--bold", X = "texts__body_text", q = "texts__body_text--bold", z = "texts__link", J = "texts__caption", K = "texts__caption--bold", Q = "page__heading", U = "filters", Y = "filters__content", Z = "filters__title-cont", $ = "filters__title", tt = "filters__clear", et = "filters__groups", st = "filters__group", i = {
  richText: k,
  heroText: E,
  mobile: P,
  tablet: N,
  desktop: S,
  buttonTextPrimary: L,
  buttonTitle: G,
  buttonTitleMap: F,
  buttonHeroTitle: H,
  headingPage: w,
  headingSection: A,
  headingMenu: O,
  textsComponentTitle: V,
  textsComponentTitleBold: j,
  textsLeadText: M,
  pageLeadText: D,
  textsLeadTextBold: I,
  textsParagraphSubtitle: R,
  textsParagraphSubtitleBold: W,
  textsBodyText: X,
  textsBodyTextBold: q,
  textsLink: z,
  textsCaption: J,
  textsCaptionBold: K,
  pageHeading: Q,
  filters: U,
  filtersContent: Y,
  filtersTitleCont: Z,
  filtersTitle: $,
  filtersClear: tt,
  filtersGroups: et,
  filtersGroup: st
}, m = {
  title: "Select a category",
  clearFilters: "Clear filters"
  // showResults: "Show results",
  // filters: "Filters",
}, dt = (_) => {
  const { wording: u, filters: o, changeHandler: a } = _, {
    title: r,
    clearFilters: n
    // showResults,
    // filters: filtersLabel,
  } = { ...m, ...u }, [l, c] = h({}), p = (e) => {
    const { name: d, value: C } = e;
    c((y) => ({ ...y, [d]: C }));
  }, t = f(() => {
    c({});
  }, []);
  return T(() => {
    a && a(l);
  }, [a, l]), /* @__PURE__ */ s.createElement(
    x,
    {
      as: "section",
      className: i.filters,
      topPadding: x.Padding.NONE,
      bottomPadding: x.Padding.NONE,
      "data-testid": "filters-block"
    },
    /* @__PURE__ */ s.createElement(
      x.Content,
      {
        className: i.filtersContent,
        flex: !0,
        "data-testid": "filters-block-content",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      /* @__PURE__ */ s.createElement("div", { className: i.filtersTitleCont }, /* @__PURE__ */ s.createElement(
        "h3",
        {
          className: g(B.textsLeadTextBold, i.filtersTitle),
          itemProp: "name"
        },
        r || m.title
      ), !!Object.values(l).filter((e) => !!e).length && /* @__PURE__ */ s.createElement("a", { href: "#", tabIndex: 0, className: i.filtersClear, onClick: t }, n || m.clearFilters)),
      /* @__PURE__ */ s.createElement(
        "div",
        {
          "data-testid": "filters-groups",
          className: g(i.filtersGroups)
        },
        Array.isArray(o) && o.map((e, d) => /* @__PURE__ */ s.createElement(
          b,
          {
            key: d,
            ...e,
            onChange: p,
            initialValues: l[e.name]?.split(",") || []
          }
        )),
        !Array.isArray(o) && /* @__PURE__ */ s.createElement(
          b,
          {
            ...o,
            onChange: p,
            initialValues: l[o.name]?.split(",") || []
          }
        )
      )
    )
  );
}, b = ({
  name: _,
  items: u,
  onChange: o,
  isMulti: a = !1,
  initialValues: r = []
}) => {
  const [n, l] = h(r);
  T(() => {
    l(r);
  }, [r]);
  const c = f(
    (t) => {
      o?.({ name: _, value: t.join(",") });
    },
    [_, o]
  ), p = f(
    (t) => {
      let e;
      a ? e = n.includes(t.value) ? n.filter((d) => d !== t.value) : [...n, t.value] : e = [t.value], l(e), c(e);
    },
    [c, n, a]
  );
  return /* @__PURE__ */ s.createElement("div", { "data-testid": "filters-group", className: i.filtersGroup }, u.map((t) => /* @__PURE__ */ s.createElement(
    v,
    {
      key: t.value,
      as: "button",
      variant: "compact",
      bolder: !0,
      onClick: () => p(t),
      text: t.label,
      selected: n?.includes(t.value),
      showXWhenSelected: a
    }
  )));
};
export {
  dt as Filters,
  b as FiltersGroup
};
//# sourceMappingURL=Filters.js.map
